import { useEffect } from "react";
import { Link } from "react-router-dom";
import image from "../../assets/blog/virtual-cam.jpg";
import { logAppEvent } from "../../modules/firebase";
import styles from "./Blog.module.scss";

export function Blog() {
  useEffect(() => {
    logAppEvent("view_blog_page");
  }, []);

  return (
    <div className={styles.blog}>
      <h3 className={styles.blogTitle}>Blog</h3>
      <div className={styles.blogPosts}>
        <Link to="/virtual-camera-with-javascript-ffi">
          <div className={styles.blogPost}>
            <div className={styles.postTitle}>
              Virtual camera with javascript & ffi
            </div>
            <img src={image} className={styles.postImage} />
            <div className={styles.postMeta}>
              <div className={styles.postTags}>
                <div className={styles.postTag}>Javascript</div>
                <div className={styles.postTag}>FFI</div>
              </div>
              <div className={styles.postDate}>26/07/2024</div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
